import * as React from 'react';
import { OnIgnoreEnter } from '../AnalyseApp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone } from '@fortawesome/free-solid-svg-icons';

interface AnalysisSetsButtonProps {
    onClick: () => void;
    activeAnalysisSetsCount: number;
}

export const AnalysisSetsButton = ({ onClick, activeAnalysisSetsCount }: AnalysisSetsButtonProps) => {
    return (
        <button id="AnalysisSets" className="btn btn-primary" type="button" onClick={() => onClick()} onKeyDown={OnIgnoreEnter}>
            <FontAwesomeIcon icon={faClone} />
            &nbsp;Analysis Sets&nbsp;
            <span id="AnalysisSetsCountBadge" className="badge badge-info">{activeAnalysisSetsCount}</span>
        </button>
    );
}
